import { css, html } from 'lit';
import { property } from 'lit/decorators.js';

import { BaseElement, customElement } from '../../components/base-element';

import '../../components/buttons/icon-button/icon-button.wc';

declare global {
  interface Window {
    Produktly?: {
      openChangelog: (options: { id: number }) => void;
    };
  }
}

@customElement('ps-universal-nav-changelog')
export class UniversalNavChangelogWC extends BaseElement {
  static styles = css`
    :host {
      display: contents;
    }
  `;

  @property({ type: Number, attribute: 'changelog-id' }) changelogId?: number;

  private handleClick(): void {
    if (!this.changelogId) {
      // eslint-disable-next-line no-console
      console.warn(
        '[ps-universal-nav-changelog] No changelog-id attribute provided.'
      );
      return;
    }
    if (!window.Produktly) {
      // eslint-disable-next-line no-console
      console.warn(
        '[ps-universal-nav-changelog] Produktly is not loaded on this page.'
      );
      return;
    }
    window.Produktly.openChangelog({ id: this.changelogId });
  }

  render() {
    return html`
      <ps-icon-button
        name="changelog"
        @click=${() => this.handleClick()}
      ></ps-icon-button>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'ps-universal-nav-changelog': UniversalNavChangelogWC;
  }
  enum PSElementTagNameMap {
    'ps-universal-nav-changelog' = 'ps-universal-nav-changelog',
  }
}
